export enum ECalendarType {
    Event,
    NewMonth,
    NewWeek,
}